<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { apiClient } from '@/apis';
import useUserStore from '@/stores/userStore';
import useDataStore from '@/stores/data';
import { LOGOUT } from '@/config/permissions';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

const { t } = useI18n();
const router = useRouter();
const { clear } = useUserStore();
const { state } = storeToRefs(useUserStore());
const { getOrganizationInfo, resetOrganizationInfo } = useDataStore();
const organizationInfo = getOrganizationInfo();

const logout = async () => {
  try {
    await apiClient.post('/accounts/logout');
    resetOrganizationInfo();
  } catch {
    //
  }

  try {
    clear();
  } catch {
    //
  }

  router.push('/login');
};

const logoutButtonAllowRender = computed(() => LOGOUT.some((k) => state.value.scope.includes(k)));

</script>
<template>
  <div class="user-profile">
    <div class="profile">
      <span
        class="profile__icon"
        aria-hidden="true"
      >
        <img
          src="@/assets/img/example-profile.png"
          alt="user icon"
        />
      </span>
      <div class="profile__text">
        <h5>{{ organizationInfo.company }}</h5>
        <p>
          <!-- <span>{{ t('부서명 노출') }}</span> -->
          <span>{{ organizationInfo.name }}</span>
        </p>
      </div>
    </div>
    <div
      v-if="logoutButtonAllowRender"
      class="user-logout user-logout--text"
      @click="logout"
    >
      <button>
        <!--
        <span class="visual_hidden">
          {{ t('common.logout') }}
        </span>
        <span class="logout-icon"></span>
        -->
        {{ t('common.logout') }}
      </button>
    </div>
  </div>
</template>
